export default () => {
  const polsatCont = document.getElementById("js-polsat-history");
  if (polsatCont) {
    const scrollItems = polsatCont.querySelector(".tv-program");
    const activeItem = scrollItems.querySelector(
      ".swiper-pagination-bullet-active"
    ).parentElement;

    if (window.innerWidth > 768) {
      scrollItems.scroll({
        top: activeItem.offsetTop - 20, // 20px - wysokosc cienia diva
        behavior: "smooth",
      });
    } else {
      scrollItems.scroll({
        left: activeItem.offsetLeft,
        behavior: "smooth",
      });
    }
  }
};
